// third party libs
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Typography from '@navi/web-ui/lib/primitives/Typography/index';
// functions and components
import LineLoader from 'src/components/SkeletonLoader/LineLoader';
import SuspenseLoader from 'src/components/SkeletonLoader/SuspenseLoader';
import { RootState } from 'src/store';
import { createKey } from 'src/utils/CaseDetail.utils';
import { IDisplayItems } from '../../interfaces/EmiSchedule.type';
// styles
import styles from './index.module.scss';
import { isFunction, pluralisation } from '@cp/src/utils/commonUtils';
import { GenericObject } from '@cp/src/types/CommonConstans';
import cx from 'classnames';
const KeyValueCards: React.FC<IDisplayItems> = props => {
  const { loanId = '', customerId = '' } = useParams();
  const details = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]?.details?.data
  );
  const { color, header, value, checkPluralization } = props;
  const displayColor = color === 'red' ? styles.red : styles.black;

  const getDisplayData = (): string | number => {
    if (isFunction(value)) {
      if (details) {
        return value(details) as string | number;
      }
      return '';
    }
    return value as string | number;
  };

  const displayData = getDisplayData();

  return (
    <div className={cx(styles.cardContainer, 'rr-block')}>
      <SuspenseLoader
        loading={!details}
        fallBack={
          <LineLoader numberOfLines={1} lineWidth={70} dimenshionUnit={'px'} childrenType={'H4'} />
        }
      >
        <Typography className={displayColor} variant={'h2'}>
          {displayData}
        </Typography>
      </SuspenseLoader>
      <Typography className={styles.headerName} variant={'p4'}>
        {checkPluralization ? pluralisation(header, Number(displayData), 's') : header}
      </Typography>
    </div>
  );
};

export default KeyValueCards;
